import { Box, Card, CardContent, Skeleton, Stack, Typography } from '@mui/material';

import { usePayments } from '@/hooks/queries/subscription/usePayments';
import { useSubscriptionPlans } from '@/hooks/queries/subscription/useSubscriptionPlans';

import PaymentHistoryItem from './PaymentHistoryItem';

const PaymentHistorySection = () => {
    const { data: payments, isLoading: isPaymentsLoading } = usePayments();
    const { data: plans } = useSubscriptionPlans();

    const planNameMap = new Map((plans ?? []).map((p) => [p.id, p.name]));

    return (
        <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 800, mb: 1.25 }}>
                결제 내역
            </Typography>

            <Card variant="outlined" sx={{ borderRadius: 3 }}>
                <CardContent sx={{ py: 1, px: 2 }}>
                    {isPaymentsLoading ? (
                        <Stack spacing={1} sx={{ py: 1 }}>
                            {[0, 1, 2].map((i) => (
                                <Skeleton key={i} variant="rectangular" height={56} sx={{ borderRadius: 1 }} />
                            ))}
                        </Stack>
                    ) : payments && payments.length > 0 ? (
                        <Box>
                            {payments.map((p) => (
                                <PaymentHistoryItem
                                    key={p.id}
                                    payment={p}
                                    planName={planNameMap.get(p.planId)}
                                />
                            ))}
                        </Box>
                    ) : (
                        <Typography variant="body2" color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
                            아직 결제 내역이 없어요.
                        </Typography>
                    )}
                </CardContent>
            </Card>
        </Box>
    );
};

export default PaymentHistorySection;
